import React from 'react'
import { FormattedMessage } from 'react-intl'

import { PackageAlert } from './PackageAlert'

type UnavailableForPickupAlertProps = {
  itemName: string
}

export const UnavailableForPickupAlert = ({
  itemName,
}: UnavailableForPickupAlertProps) => (
  <PackageAlert>
    <FormattedMessage
      id="checkout.pickup-in-store-unavailable"
      values={{ itemName }}
    />
  </PackageAlert>
)
